// extracted by mini-css-extract-plugin
export default {"container":"cYs_","tab":"e3IT","activeTab":"JpGI"};